'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { paginationPageButtonRecipe } from './styles/pagination-page-button.styles';
import type { PaginationPageButtonPropsInterface } from './types/pagination-page-button.types';

/**
 * The numbered page `button` elements
 * @since 10.0.0
 */
export const PaginationPageButton = forwardRef<
  HTMLButtonElement,
  PaginationPageButtonPropsInterface
>((props: PaginationPageButtonPropsInterface, forwardedRef) => {
  const { asChild = false, children, className, css: cssProp, selected = false, ...rest } = props;

  const styles = css(paginationPageButtonRecipe.raw({ selected }), cssProp);

  const Component = asChild ? Slot : 'button';

  return (
    <Component
      ref={forwardedRef}
      data-c11n-component="Pagination.PageButton"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', styles, className)}
      type={asChild ? undefined : 'button'}
      {...rest}
    >
      {children}
    </Component>
  );
});

PaginationPageButton.displayName = 'Pagination.PageButton';
